import { render, staticRenderFns } from "./deliverGoodsRecord.vue?vue&type=template&id=063b1f90&scoped=true&"
import script from "./deliverGoodsRecord.vue?vue&type=script&lang=js&"
export * from "./deliverGoodsRecord.vue?vue&type=script&lang=js&"
import style0 from "./deliverGoodsRecord.vue?vue&type=style&index=0&id=063b1f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b1f90",
  null
  
)

export default component.exports